import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import AuthProvider from 'src/auth/AuthProvider';
import { BaseLayoutWithLocation } from 'src/components/BaseLayout';
import { setRoutesConfig } from 'src/redux/routesConfig/actions';
import { getAppRoutes } from 'src/routes/App';

function App() {
  const [appRoot] = useState('/');
  const dispatch = useDispatch();
  const routesConfig = useSelector(state => state.routesConfig);

  useEffect(() => {
    window.djconfig = {
      appRoot: appRoot,
      ...window.djconfig,
    };
    dispatch(setRoutesConfig(getAppRoutes(appRoot)));
  }, []);

  if (!routesConfig.root) return null;

  const CloseButton = ({ closeToast }) => (
    <button className="Toastify__close-button" onClick={closeToast}>
      <span></span>
    </button>
  );

  return (
    <>
      <Helmet titleTemplate="SPRING-UI | %s">
        <title>Home</title>
      </Helmet>

      <BrowserRouter>
        <Routes>
          <Route
            path="/*"
            element={
              <AuthProvider forceLogin>
                <BaseLayoutWithLocation />
                <ToastContainer
                  position="bottom-right"
                  closeButton={<CloseButton />}
                />
              </AuthProvider>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
